var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c(
        "v-main",
        [
          _c("PluginAlert"),
          _c("PluginConfirmDialog"),
          _c("PluginLoading"),
          _c("MainToolbar"),
          _c("router-view"),
          _c("DocumentDialog"),
          _c("SignInDialog"),
          _c("ForgotPasswordDialog"),
          _c("ConfirmForgotPasswordDialog"),
          _c("NewPasswordDialog"),
          _vm.useCommonSignUp ? _c("PrimarySignUpDialog") : _c("SignUpDialog"),
          _c("ConfirmSignupDialog")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }